import { jsxs, jsx } from 'react/jsx-runtime';
import gsap from 'gsap';
import { useCallback } from 'react';
import { shallow as shallow$1 } from '../../../node_modules/zustand/esm/shallow.js';
import { styled } from 'styled-components';
import { Link } from '@fabric-app/compat';
import useAlertStore from '../../store/alerts.js';
import { mediaMobile } from '@fabric-app/ui/constants/styled-utils';
import Tooltip from '@fabric-app/ui/components/Tooltip';
import { CloseIcon } from '@fabric-app/icons/icons';

const Banner = styled.div.withConfig({
  displayName: "BannerDisplay__Banner",
  componentId: "sc-eaba4684-0"
})([
  `position:relative;width:100%;height:38px;margin-top:env(safe-area-inset-top);display:flex;padding:6px 12px;padding-right:38px;justify-content:center;align-items:center;gap:10px;align-self:stretch;color:#000;text-align:center;font-family:Inter;font-size:12px;font-style:normal;font-weight:500;> span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}background:#e2e2e2;&[data-severity='danger']{background:#ff9a3c;}&[data-severity='warning']{background:#ffcd1c;}&[data-severity='info']{background:#e2e2e2;}&[data-severity='announcement']{color:white;background:#bb65ff;}`,
  `{padding:6px;padding-right:30px;}`
], mediaMobile);
const CloseButton = styled.button.withConfig({
  displayName: "BannerDisplay__CloseButton",
  componentId: "sc-eaba4684-1"
})([
  `display:flex;align-items:center;justify-content:center;position:absolute;right:0;top:0;bottom:0;width:38px;`,
  `{width:30px;}`
], mediaMobile);
const ActionButton = styled.button.withConfig({
  displayName: "BannerDisplay__ActionButton",
  componentId: "sc-eaba4684-2"
})([
  `display:flex;padding:3px 10px;justify-content:center;align-items:center;gap:10px;border-radius:6px;background:#fff;font-size:12px;font-weight:500;flex-shrink:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`
]);
const renderBannerAction = (action) => {
  if (!action) return null;
  switch (action.type) {
    case "url":
      return /* @__PURE__ */ jsx(Link, {
        href: action.url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /* @__PURE__ */ jsx(ActionButton, {
          children: action.label
        })
      });
    case "path":
      return /* @__PURE__ */ jsx(Link, {
        href: action.path,
        passHref: true,
        children: /* @__PURE__ */ jsx(ActionButton, {
          children: action.label
        })
      });
    case "refresh":
      return /* @__PURE__ */ jsx(ActionButton, {
        onClick: () => window.location.reload(),
        children: action.label
      });
    default:
      return null;
  }
};
const BannerDisplay = ({ alert: banner }) => {
  const dismissBanner = useAlertStore((state) => state.dismissBanner, shallow$1);
  const elementId = `banner-${banner.id}`;
  const hideAlert = useCallback(() => {
    gsap.to(`#${elementId}`, {
      duration: 0.5,
      opacity: 0,
      onComplete: () => {
        dismissBanner();
      }
    });
  }, [
    dismissBanner,
    elementId
  ]);
  return /* @__PURE__ */ jsxs(Banner, {
    "data-severity": banner.severity,
    id: elementId,
    children: [
      /* @__PURE__ */ jsx(Tooltip, {
        label: banner.content,
        children: /* @__PURE__ */ jsx("span", {
          children: banner.title
        })
      }),
      renderBannerAction(banner.action),
      /* @__PURE__ */ jsx(CloseButton, {
        onClick: hideAlert,
        children: /* @__PURE__ */ jsx(CloseIcon, {})
      })
    ]
  });
};

export { BannerDisplay as default };
//# sourceMappingURL=BannerDisplay.js.map
